import { htmlToPlainText, isConfirmButtonRole, roleFromClasses } from './confirmText.js';
export const CONFIRM_DIALOG_HEADER = 'x-client-confirm-dialog';
export function readConfirmPrompt(rejection) {
  if (rejection === null || typeof rejection !== 'object') return null;
  const shape = rejection;
  if (shape.status !== 400) return null;
  if (typeof shape.headers !== 'function') return null;
  const getHeader = shape.headers;
  let flag;
  try {
    flag = getHeader(CONFIRM_DIALOG_HEADER);
  } catch (e) {
    return null;
  }
  if (!flag) return null;
  return parsePromptBody(shape.data);
}
function parsePromptBody(data) {
  const body = data !== null && typeof data === 'object' ? (data) : {};
  const options = body.options !== null && typeof body.options === 'object' ? (body.options) : {};
  const message = typeof options.message === 'string' ? options.message : '';
  const prompt = {
    type: typeof body.type === 'string' ? body.type : '',
    message,
    text: typeof options.text === 'string' ? options.text : htmlToPlainText(message),
    buttons: parseButtons(options.buttons)
  };
  if (typeof options.title === 'string') prompt.title = options.title;
  if (Array.isArray(options.items)) {
    prompt.items = options.items.filter(item => typeof item === 'string');
  }
  return prompt;
}
function parseButtons(raw) {
  if (!Array.isArray(raw)) return [];
  const buttons = [];
  for (const entry of raw) {
    if (entry === null || typeof entry !== 'object') continue;
    const button = entry;
    if (typeof button.key !== 'string' || button.key.length === 0) continue;
    const classes = typeof button.classes === 'string' ? button.classes : undefined;
    const parsed = {
      key: button.key,
      label: typeof button.label === 'string' ? button.label : button.key,
      role: isConfirmButtonRole(button.role) ? button.role : roleFromClasses(classes)
    };
    if (classes !== undefined) parsed.classes = classes;
    buttons.push(parsed);
  }
  return buttons;
}
export function withConfirmAnswers(req, answers) {
  if (Object.keys(answers).length === 0) return req;
  return Object.assign({}, req, {
    headers: Object.assign({}, req.headers, {
      [CONFIRM_DIALOG_HEADER]: JSON.stringify(answers)
    })
  });
}